<template>
	<el-dialog title="提示" width="500px" :visible.sync="visible">
		<el-form :model="ruleFromParams" :rules="rules" ref="ruleForm">
			<el-form-item label="退款原因" prop="reject">
				<el-input :maxlength="200" show-word-limit :autosize="{ minRows: 3, maxRows: 5}" placeholder="请输入退款原因" type="textarea" v-model="ruleFromParams.reject"/>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="cancelFun">取 消</el-button>
			<el-button type="primary" @click="rejectSure">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
	import { mapActions } from 'vuex'
	export default {
		props: {
			value: {
				type: Boolean,
				default: false
			},
			id: {
				type: [Number, String],
				default: -1
			},
			channel_type:{
				type: [Number, String],
				default: ''
    		}
		},
		data() {
			return {
				ruleFromParams: {
					reject: ''
				},
				rules:{
					reject: [
						{
							required: true,
							message: '请输入退款原因',
							trigger: 'blur'
						}
					]
				}
			}
		},
		computed: {
			visible: {
				get() {
					return this.value
				},
				set(news) {
					if(!news) {
						this.ruleFromParams.reject = ''
						this.$refs.ruleForm.clearValidate()
					}
					this.$emit('input', news)
				}
			}
		},
		methods: {
			...mapActions('withdrawal', ['submitOrderRefund']),
			cancelFun() {
				this.visible = false
			},
			rejectSure() {
				this.$refs.ruleForm.validate(async (valid) => {
					if(valid) {
					 	await this.submitOrderRefund({ id: this.id, reason: this.ruleFromParams.reject,channel_type:this.channel_type })
						this.visible = false
						this.$message({
							type: 'success',
							message: '退款成功',
							duration: 3000
						})
						this.$emit('result')
					}
				})
			}
		}
	}
</script>
<style lang="less" scoped></style>
